import type { PopoverActions } from '@mui/material';
import { Menu } from '@mui/material';
import type { ReactNode, Ref } from 'react';

interface Props {
  actionRef: Ref<PopoverActions>;
  anchorEl: HTMLElement | null;
  children: ReactNode;
  onClose: () => void;
}

export function GroupItemMenu({
  actionRef,
  anchorEl,
  children,
  onClose,
}: Props) {
  return (
    <Menu
      sx={{ zIndex: 1301 }}
      MenuListProps={{
        disablePadding: true,
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          sx: {
            width: 224,
            borderRadius: 2,
            p: 1,
          },
        },
      }}
      action={actionRef}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClick={onClose}
      onClose={onClose}
    >
      {children}
    </Menu>
  );
}
